// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__A11Tj","signatureBlock":"Footer_signatureBlock__3NUAY","signature":"Footer_signature__2ppWp"};